import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { ReportsService } from 'src/app/services/reports.service';
import { Table } from 'primeng/table';
import saveAs from 'file-saver';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-subsidy-wise-report',
  templateUrl: './subsidy-wise-report.component.html',
  styleUrls: ['./subsidy-wise-report.component.scss'],
})
export class SubsidyWiseReportComponent implements OnInit {
  @ViewChild('subsidyWiseDetails', { static: true }) 
  public subsidyWiseDetails: Table;
  
  public districtData: any = [];
  public selectedDistrict: any = null;

  public blockData: any = [];
  public selectedBlock: any = null;

  public villageData: any = [];
  public selectedVillage: any = null;

  public loading: boolean = false;
  public userId: any;
  public tableDataToShow: any = [];
  public subscriptions: any = [];
  public subjectSub: any;
  public showTable: boolean = false;
  public selectedYear: any;
  public exportType: MenuItem[];
  public date: any;

  constructor(
    private reportsService: ReportsService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private router: Router,
    private service: BaseService,
    private cryptoJsService: CryptoJsService
  ) {}

  ngOnInit(): void {
    this.date = new Date();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.getDistrictMasterData();

    this.exportType = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.tableDataToShow, `Subsidy Wise Details (${this.date})`);
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.tableDataToShow, "Subsidy_Wise_Details");
      //   }
      // },
    ];

  }

  getDistrictMasterData() {
    this.loader.start();
    this.reportsService
      .getDistrictMaster()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.districtData = data;
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectDistrict() {
    this.closeActiveAPIs();
    this.tableDataToShow = [];
    this.blockData = [];
    this.selectedBlock = null;
    this.getBlockMasterData(this.selectedDistrict?.Dist_Code);
  }
  
  getBlockMasterData(distCode) {
    this.loader.start();
    this.reportsService
      .getBlockMaster(distCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.blockData = data;
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }


  onSelectBlock() {
    this.tableDataToShow = [];
    this.closeActiveAPIs();
    this.loadTableData();
    this.showTable = true;
  }

  // onSelectVillage() {
  //   this.closeActiveAPIs();
  //   this.loadTableData();
  // }

  loadTableData() {
    let reqBody = {
      Dist_Code: this.selectedDistrict?.Dist_Code,
      Block_Code: this.selectedBlock?.Block_Code,
      Vill_Code: '',
    };

    this.loadData(reqBody);
  }

  // loadDataAndApplyFilter(reqBody){
  //   if(sessionStorage.getItem('financialYear')){
  //     this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
  //   }

  //   this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
  //     (res) => {
  //       this.loadData(reqBody);
   
  //       this.selectedYear = res;
  //       this.subsidyWiseDetails.filters['FinYear'] = [
  //         { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' }];
  //     }
  //   );
  // }

  loadData(reqBody: any) {
    this.loading = true;
    let sub = this.reportsService
      .getDrillDownSubsidyDetail(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // console.log('data', data);
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userId,
            'Subsidy Wise Details',
            '',
            new Date(),
            'Success'
          );

          if (data?.length > 0) {
            this.tableDataToShow = data;
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
            this.tableDataToShow = [];
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userId,
            'Subsidy Wise Details',
            '',
            new Date(),
            err
          );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    this.subscriptions.push(sub);
  }

  closeActiveAPIs() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.closeActiveAPIs();
  }

  selectFarmerApplication(application) {
    if (application?.AppID) {
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application?.AppID)]));

      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.AppID.toString()) } }));
      window.open(link, '_blank');
    }
    else{
      this.messageService.add({
        summary: 'Error Message',
        severity: 'info',
        detail: 'Application Id Not Found',
      });
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "App Id" : d.AppID,
          "District": d.District,
          "Block" : d.Block,
          "Village": d.Village,
          "Programme Name": d.ProgramName,
          "Vendor Name": d.VendorName,
          "Scheme": d.Scheme,
          "Type of Water Source": d.Water_Source_Name,
          "Financial Year": d.FinYear,
          "Farmer Share To Vendor": d.FarmerShare_to_Vendor,
          "Subsidy To Vendor": d.Subsidy_to_Vendor,
          "Subsidy To Farmer": d.Subsidy_Amt_Farmer,
          "Subsidy Amount Stage 1": d.Subsidy_Amt_Stage1,
          "Subsidy Amount Stage 2": d.Subsidy_Amt_Stage2,
          "Subsidy Amount Stage 3": d.Subsidy_Amt_Stage3,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  
}
